export default function PadInline({ children }: { children: React.ReactNode }) {
  return <div style={{ paddingInline: "13px" }}>{children}</div>;
}
